import { cipo } from 'cipo';

cipo.factory('printService', ['$timeout', 'fileService', function ($timeout, fileService) {

    var printService = {};

    printService.printPdfFileToIframe = function(file) {
        $timeout(function () {
            var url = window.URL.createObjectURL(file);
            var iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = url;
            document.body.appendChild(iframe);

            var cleanup = function (revokeUrlDelayMs) {
                iframe.remove();

                if (revokeUrlDelayMs > 0) {
                    setTimeout(function () {
                        window.URL.revokeObjectURL(url);
                    }, revokeUrlDelayMs);
                } else {
                    window.URL.revokeObjectURL(url);
                }

                window.removeEventListener('afterprint', handleAfterPrint);
            };

            var openInNewTabForManualPrint = function () {
                window.open(url, '_blank', 'noopener,noreferrer');
                cleanup(60000);
            };

            var handleAfterPrint = function () {
                cleanup();
            };

            iframe.onload = function () {
                window.addEventListener('afterprint', handleAfterPrint);

                $timeout(function () {
                    var frameWindow = iframe.contentWindow;
                    if (!frameWindow) {
                        openInNewTabForManualPrint();
                        return;
                    }

                    try {
                        frameWindow.focus();
                        frameWindow.print();
                    } catch (e) {
                        openInNewTabForManualPrint();
                    }
                }, 250);
            };
        }, 0);
    }

    printService.printPdfToIframe = function(content) {
        printService.printPdfFileToIframe(fileService.createFile(content, '', 'application/pdf'));
    }

    return printService;
}]);